import { ToneDtoImpl, ToneDto } from '../tonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';
import { BaseContext } from '../../../utils/basecontext';

export class FeaturedCategoryBuilder
{
    constructor(private featuredCategoryList: any, private context: BaseContext)
    {
        if(featuredCategoryList.recommendationSongsList === undefined)
        {
            throw new NoDataException("Featured Category data doesnt exists");
        }
    }

    buildAll(): ToneDto[]
    {
        return this.parseFeaturedCategoryDetailsResponse();
    }
    
    private parseFeaturedCategoryDetailsResponse(): ToneDto[]
    {
        let listOfFeaturedCategory: ToneDto[] = [];
        
        let toneDto = null;
        this.featuredCategoryList.recommendationSongsList.forEach((recommendedSongJson: any) =>
        {
            toneDto = new ToneDtoImpl();
            toneDto.setId(recommendedSongJson.toneId);
            toneDto.setToneName(recommendedSongJson.toneName);
            toneDto.setAlbumName(recommendedSongJson.albumName);
            toneDto.setArtistName(recommendedSongJson.artistName);
            toneDto.setToneUrl(recommendedSongJson.toneIdStreamingUrl);
            toneDto.setImgPath(recommendedSongJson.toneIdpreviewImageUrl);
            toneDto.setDownloadCount(recommendedSongJson.downloadCount);
            toneDto.setLikeCount(recommendedSongJson.likeCount);
            toneDto.setExpirydate(DateFormat.formatExpiryDate(recommendedSongJson.expiryDate, this.context));
            
            listOfFeaturedCategory.push(toneDto);
        });
        return listOfFeaturedCategory;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorybuilder.ts